import Api from "../../config/ApiConfig";
import * as types from "./types";

const apiUrls = {
    workflows: "api/v1/workflows/dif/triggers",    
}

export const postWorkflows = (payload: types.IWorkflowParams) =>
 Api.post(apiUrls.workflows, payload)
      .then((response) => { return response; })
      .catch((error) => { return error.response; });